interface ContentLayoutProps {
  breadcrumbs?: React.ReactNode;
  footerNavigation?: React.ReactNode;
  children: React.ReactNode;
}

export default function ContentLayout({
  breadcrumbs,
  footerNavigation,
  children,
}: ContentLayoutProps) {
  return (
    <>
      {breadcrumbs && (
        <div className="flex-shrink-0 bg-base-100 px-3 sm:px-4 max-w-4xl">
          {breadcrumbs}
        </div>
      )}

      {children}

      {footerNavigation && (
        <div className="bg-base-100 px-3 sm:px-4 py-2 max-w-4xl">
          {footerNavigation}
        </div>
      )}
    </>
  );
}
